const apiUrl = "https://mitserver.app:7000";
module.exports = {
	apiUrl,
};
